import { getCurrencyValuation } from "@/_core/data/api_calls/valuation_data/getCurrencyValuation";
import { getCommodityValuation } from "@/_core/data/api_calls/valuation_data/getCommodityValuation";

export function getValuationData(ctx, asset) {
  if (asset === "currency") {
    return getCurrencyValuation(ctx);
  } else if (asset === "commodity") {
    return getCommodityValuation(ctx);
  }
}
